import { Dialog, styled } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { FC, ReactNode } from "react"
import { ScreenReaderAnnouncer } from "../../../../components/common/ScreenReaderAnnouncer"

type FullscreenImageModalProps = {
  opened: boolean
  onClose: () => void
  children?: ReactNode
  disableRestoreFocus?: boolean
}

const DIALOG_TITLE_ID = "fullscreen-image-dialog-title"

export const FullscreenImageModal: FC<FullscreenImageModalProps> = props => {
  const { opened, onClose, children, disableRestoreFocus } = props
  return (
    <StyledDialog
      open={opened}
      onClose={onClose}
      aria-labelledby={DIALOG_TITLE_ID}
      disableRestoreFocus={disableRestoreFocus}
    >
      <span id={DIALOG_TITLE_ID} style={visuallyHidden}>
        Fullscreen image viewer
      </span>
      <ScreenReaderAnnouncer />
      {children}
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    maxWidth: "70vw",
    width: "100%"
  }
}))
